<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="formRef" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="签约列表">
          <el-row :gutter="20">
            <el-col :span="6">分店</el-col>
            <el-col :span="6">房价码</el-col>
            <el-col :span="5">操作</el-col>
          </el-row>
        </el-form-item>
        <el-form-item v-for="(item, index) of form.contractList" :key="index">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-select v-model="item.branchId" placeholder="选择分店">
                <el-option
                  v-for="item in branchList"
                  :key="item.branchId"
                  :label="item.title"
                  :value="item.branchId"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="item.rateCodeId" placeholder="选择房价码">
                <el-option
                  v-for="item in rateCodeList"
                  :key="item.rateCodeId"
                  :label="item.title"
                  :value="item.rateCodeId"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="5">
              <el-button type="primary" @click="add">添加</el-button>
              <el-button v-if="index != 0" type="danger" @click="del(index)">
                删除
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.step" size="mini">
            <el-radio-button :label="1">已生效</el-radio-button>
            <el-radio-button :label="2">待生效</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开始日期" prop="startDate">
          <el-date-picker
            v-model="form.startDate"
            type="date"
            value-format="YYYY-MM-DD"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" prop="endDate">
          <el-date-picker
            v-model="form.endDate"
            type="date"
            value-format="YYYY-MM-DD"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="签约销售员工" prop="createPeopleId">
          <el-select
            v-model="form.createPeopleId"
            placeholder="请选择签约销售员工"
            class="fix-width"
            clearable
          >
            <el-option
              v-for="item in staffList"
              :key="item.peopleId"
              :label="item.basic.name"
              :value="item.peopleId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="维护销售员工" prop="followPeopleId">
          <el-select
            v-model="form.followPeopleId"
            placeholder="请选择维护销售员工"
            class="fix-width"
            clearable
          >
            <el-option
              v-for="item in staffList"
              :key="item.peopleId"
              :label="item.basic.name"
              :value="item.peopleId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="text">
          <el-input
            v-model="form.text"
            type="textarea"
            class="fix-width"
            placeholder="请输入备注"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close(formRef)">取 消</el-button>
        <el-button type="primary" @click="save(formRef)">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createContractCompany, updateContractCompany } from '@/api/room'
import commomFunction from '../common'
import { ref, reactive, getCurrentInstance } from 'vue'
export default {
  name: 'CompanyEdit',
  emits: ['fetch-data'],
  setup(_, { emit }) {
    const { proxy } = getCurrentInstance()
    const title = ref('')
    const dialogFormVisible = ref(false)
    const formRef = ref(null)
    const { branchList, staffList, rateCodeList } = commomFunction()
    const initForm = () => {
      return {
        contractCompanyId: '',
        title: '',
        contractList: [
          {
            branchId: '',
            rateCodeId: '',
          },
        ],
        startDate: '',
        endDate: '',
        createPeopleId: '',
        followPeopleId: '',
        text: '',
        step: 1,
        order: 1,
      }
    }
    const form = reactive(initForm())
    const rules = {
      title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
      startDate: [
        { required: true, trigger: 'blur', message: '请选择开始日期' },
      ],
      endDate: [{ required: true, trigger: 'blur', message: '请选择结束日期' }],
      createPeopleId: [
        { required: true, trigger: 'blur', message: '请选择签约销售员工' },
      ],
      followPeopleId: [
        { required: true, trigger: 'blur', message: '请选择维护销售员工' },
      ],
    }
    const add = () => {
      form.contractList.push({ branchId: '', rateCodeId: '' })
    }
    const del = (index) => {
      form.contractList.splice(index, 1)
    }
    const showEdit = async (row) => {
      if (row && row.contractCompanyId) {
        title.value = '修改协议客户'
        form.text = row.basic.text
        form.order = row.basic.order
        form.contractCompanyId = row.contractCompanyId
        form.title = row.title
        form.step = row.step
        form.contractList = row.basic.contractList
        form.startDate = row.basic.startDate
        form.endDate = row.basic.endDate
        form.createPeopleId = row.basic.createPeopleId
        form.followPeopleId = row.basic.followPeopleId
      } else {
        title.value = '新增协议客户'
      }
      dialogFormVisible.value = true
    }
    const formReset = (formRef) => {
      if (!formRef) return
      formRef.resetFields()
      Object.assign(form,initForm())
    }
    const close = (formRef) => {
      formReset(formRef)
      dialogFormVisible.value = false
    }
    const save = (formRef) => {
      if (!formRef) return
      formRef.validate(async (valid) => {
        if (valid) {
          try {
            form.contractList.forEach((e) => {
              if (!e.branchId) {
                throw '请选择分店'
              }
              if (!e.rateCodeId) {
                throw '请选择房价码'
              }
            })
          } catch (error) {
            return proxy.$message.warning(error)
          }
          const contractCompanyId = form.contractCompanyId
          const data = Object.assign({}, form)
          proxy.$baseConfirm(
            `你确定要${contractCompanyId ? '修改' : '新增'}协议客户吗`,
            null,
            async () => {
              contractCompanyId
                ? await updateContractCompany(data)
                : await createContractCompany(data)
              proxy.$baseMessage(
                `${contractCompanyId ? '修改' : '新增'}协议客户成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              emit('fetch-data')
              close(formRef)
            }
          )
        } else {
          return false
        }
      })
    }
    return {
      title,
      branchList,
      formRef,
      form,
      rules,
      dialogFormVisible,
      staffList,
      rateCodeList,
      add,
      del,
      showEdit,
      close,
      save,
    }
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.icon_avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
  margin-left: 15px;
}

.mr-10 {
  margin-right: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>
